import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createBlock(_component_q_input, {
    modelValue: _ctx.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
    outlined: true,
    dense: _ctx.dense,
    "bg-color": "white",
    type: "email",
    color: "primary",
    label: `${_ctx.$t('widgetEnterEmail')}*`,
    error: _ctx.showError,
    rules: [_ctx.validateEmail]
  }, null, 8, ["modelValue", "dense", "label", "error", "rules"]))
}